// ORCA360 - Device Context Provider
// Wraps the app so any component can access device type without prop drilling.
// Usage: const { isMobile, isDesktop, isPWA } = useDevice();

import { createContext, useContext, ReactNode } from 'react';
import { useDeviceType } from '../hooks/useDeviceType';

interface DeviceContextType {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isPWA: boolean;
}

const DeviceContext = createContext<DeviceContextType | undefined>(undefined);

export function DeviceProvider({ children }: { children: ReactNode }) {
  const device = useDeviceType();

  return (
    <DeviceContext.Provider value={device}>
      {children}
    </DeviceContext.Provider>
  );
}

export function useDevice(): DeviceContextType {
  const context = useContext(DeviceContext);
  if (context === undefined) {
    throw new Error('useDevice must be used within a DeviceProvider');
  }
  return context;
}
